<template lang="pug">
v-expansion-panels(dense='' v-model='jj_expaned')
  v-expansion-panel
    v-card
      v-list
        v-expansion-panel-header
          v-list-item
            v-list-item-content
              v-list-item-subtitle {{$t(header.kk)}}
              span.line-clamp(v-if='jj_expaned==undefined' v-html='jj[header.key]')
              span(v-else v-html='jj[header.key]')
        v-expansion-panel-content
          v-list-item(v-for='({key, kk}, n) in contents.slice(1)' :key='`jj_contents_${n}`')
            v-list-item-content
              v-list-item-subtitle {{$t(kk)}}
              span(style='white-space: pre-line;' v-text='jj[key]')
</template>
<script>
import {debug} from "@/api/logging"
import { ref, computed, watch, toRefs } from '@vue/composition-api'
import i18n from '@/i18n'
import {$en} from '@/api/util'

const content_mappings = {
  intro: '期刊簡介',
  journal_name: '期刊名稱',
  isbn_issn: 'ISBN/ISSN',
  publish: '出版單位',
  setsubject: '主題',
  interval: '出版周期',
  status: '出版現況',
  year: '創刊年',
  city: '城市',
  language: '語言',
}
export default {
  props: {
    jj: {},
    noHover: {},
  },
  setup(props) {
    const {jj, noHover} = toRefs(props)
    const jj_expaned = ref()
    const expand = function(hover) {
      if(noHover.value) {
        return 0
      }
      else {
        return hover ? 0 : undefined
      }
    }
    const contents = computed(()=>{
      // TODO: 檢查shielding，特定uniname的 出版單位 期刊名稱 拿掉
      let rr = Array()
      for(let key in content_mappings) {
        if(jj.value[key]) {
          const kk = `jinfo.${key}`
          const colname = content_mappings[key]
          // debug('kk', kk, colname)
          key = $en(key)
          rr.push({key, kk, colname})
        }
      }
      return rr
    })
    const header = computed(()=>{
      return contents.value.length > 0 ? contents.value[0] : {}
    })

    return {
      header, contents,
      jj_expaned,
      expand,
    }
  },
}
</script>
<style scoped>
.line-clamp {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;  
}
</style>